"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
const ActionType_1 = require("./actions/ActionType");
function reducer(state, action) {
    switch (action.type) {
        case ActionType_1.ActionType.SetCurrentPage:
            return Object.assign(Object.assign({}, state), { currentPage: action.payload.currentPage });
        case ActionType_1.ActionType.SetPagesCount:
            return Object.assign(Object.assign({}, state), { pagesCount: action.payload.pagesCount });
        case ActionType_1.ActionType.SetNextRoute:
            return Object.assign(Object.assign({}, state), { nextRoute: action.payload.nextRoute });
        case ActionType_1.ActionType.SetCanGoNext:
            return Object.assign(Object.assign({}, state), { canGoNext: action.payload.canGoNext });
        default:
            // @ts-ignore
            throw new Error(`Unsupported action type: ${action.type}`);
    }
}
exports.reducer = reducer;
